import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

import createBlueprintIcon from "images/tileIcons/createBlueprint.svg";

import { TypeIcon, InfoItem } from "components/Home/Utils/Utils";
import getStyles from "components/Home/Utils/getStyles";

import styles from "./style.module.css";

const bpStyles = getStyles("blueprint");

export default class BlueprintTile extends React.PureComponent {
  render() {
    const { blueprint, isCreate, isPurchased, isCreator, isHighlight, onClick } = this.props;

    if (isCreate) {
      return <CreateBlueprintTile onClick={onClick} />;
    }

    if (!blueprint) {
      return <React.Fragment></React.Fragment>;
    }

    return (
      <div className={styles.tileWrapper}>
        <div
          className={
            (onClick ? styles.tile : styles.tileNoHover) + (isHighlight ? " " + styles.blueprintHighlight : "")
          }
          onClick={() => {
            if (onClick) {
              return onClick();
            } else return;
          }}
        >
          <TileOverlay isPurchased={isPurchased} isCreator={isCreator} />
          <div className={styles.tileHeader + " " + bpStyles.background}>
            <h1 title={blueprint.name} className={bpStyles.text}>
              {blueprint.name}
            </h1>

            <div className={styles.tileHeaderContent}>
              <TypeIcon hideMobile type="blueprint" size={"70px"} />
            </div>
          </div>
          <div className={styles.tileBody}>
            {blueprint.created_by ? (
              <InfoItem
                icon={<FontAwesomeIcon icon={faUser} />}
                iconStyle={{ color: styles.aibleColor }}
                text={blueprint.created_by.fullname}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}

class TileOverlay extends React.PureComponent {
  render() {
    const { isPurchased, isCreator } = this.props;
    let text = "";
    if (isPurchased) {
      text = "purchased";
    }
    if (isCreator) {
      text = "creator";
    }
    if (!text) {
      return <React.Fragment></React.Fragment>;
    }
    return (
      <div className={styles.tileOverlay}>
        <h1>{text}</h1>
      </div>
    );
  }
}

export class CreateBlueprintTile extends React.PureComponent {
  render() {
    const { onClick } = this.props;
    const text = "Create Blueprint";
    return (
      <div className={styles.tileWrapper}>
        <div className={onClick ? styles.tile : styles.tileNoHover} onClick={onClick ? () => onClick() : undefined}>
          <div className={styles.tileHeader}>
            <div className={styles.createTileIcon}>
              <img src={createBlueprintIcon} alt={text} />
            </div>
          </div>
          <div className={styles.tileBody}>
            <div className={styles.createTileHeader + " " + bpStyles.text}>{text}</div>
          </div>
        </div>
      </div>
    );
  }
}
